import React from 'react';
import {
  SaveButton,
  CREATE,
  fetchEnd,
  fetchStart,
  showNotification,
  Create,
  refreshView
} from 'react-admin';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { connect } from 'react-redux';
import { FormSpy } from 'react-final-form';

import dataProvider from '../../core/providers/IccUserDataProvider';
import CategorySummary from '../categories/CategorySummary';
import DialogTitleWithCloseButton from '../../core/components/DialogTitleWithCloseButton';
import SimpleFormWithSave from '../../core/components/form/SimpleFormWithSave';
import { withStyles } from '@material-ui/core/styles';
import { getIcError } from '../../core/providers/utils';

const styles = () => ({
  fullWidth: {
    width: '100%'
  }
});

class CategoryCreateDialog extends React.Component {
  categoryFormProps;

  state = {
    submitting: false
  };

  setCategoryFormProps = props => {
    this.categoryFormProps = props;
  };

  handleSaveClick = event => {
    // Trigger a submit of our custom quick create/update form
    // This is needed because our modal action buttons are oustide the form
    this.categoryFormProps.form.submit(event);
  };

  handleClose = () => {
    const { handleDialogToggle } = this.props;
    const { submitting } = this.state;
    if (submitting) return;
    this.categoryFormProps.form.reset();
    handleDialogToggle();
  };

  handleSubmit = values => {
    const {
      fetchStart,
      fetchEnd,
      showNotification,
      handleDialogToggle,
      groupId,
      refreshView
    } = this.props;

    this.setState({ submitting: true });

    // Dispatch an action letting react-admin know a API call is ongoing
    fetchStart();

    // As we want to know when the new category has been created in order to close the modal, we use the
    // dataProvider directly
    dataProvider(CREATE, 'categories', { data: values })
      .then(({ data }) => {
        // Create groupcategories relation with the new created category
        dataProvider(CREATE, 'groupcategories', {
          data: { groupId, categoryOrSubcategoryId: data.id }
        })
          .then(() => {
            refreshView();
            handleDialogToggle();
          })
          .catch(groupCategoriesError => {
            showNotification('ra.notification.server', 'error', {
              messageArgs: { message: getIcError(groupCategoriesError) }
            });
          });
      })
      .catch(error => {
        showNotification('ra.notification.server', 'error', {
          messageArgs: { message: getIcError(error) }
        });
      })
      .finally(() => {
        // Dispatch an action letting react-admin know a API call has ended
        this.categoryFormProps.form.reset();
        fetchEnd();
        this.setState({ submitting: false });
      });
  };

  render() {
    const {
      showDialog,
      showNotification,
      fetchStart,
      fetchEnd,
      classes,
      refreshView,
      ...createProps
    } = this.props;
    const { submitting } = this.state;

    return (
      <Dialog
        fullWidth
        open={showDialog}
        aria-label={`Create new Category`}
        maxWidth="md"
        onClose={(event, reason) => {
          if (reason === 'backdropClick') return null;
          this.handleClose();
        }}
      >
        <DialogTitleWithCloseButton onClose={this.handleClose}>
          Create New Category
        </DialogTitleWithCloseButton>
        <DialogContent>
          {/* Override record object that contains investor information */}
          <Create
            {...createProps}
            record={{
              fundLevelFreeze: false,
              order: 0,
              triggerEmail: false,
              description: '',
              templateId: 0,
              categoryTypeId: 0,
              subType: 'REPORTING',
              status: 'ACTIVE',
              excludeFromDailySummary: false
            }}
            className={classes.fullWidth}
          >
            <SimpleFormWithSave
              toolbar={null}
              resource="categories"
              // We override the redux-form onSubmit prop to handle the submission ourselves
              onSave={this.handleSubmit}
              variant="standard"
              margin="normal"
            >
              <FormSpy>
                {props => {
                  this.setCategoryFormProps(props);
                  return <CategorySummary creation={true} variant="standard" />;
                }}
              </FormSpy>
            </SimpleFormWithSave>
          </Create>
        </DialogContent>
        <DialogActions>
          <SaveButton
            saving={submitting}
            handleSubmitWithRedirect={this.handleSaveClick}
            label="Create and Add"
            icon={<></>}
          />
          <Button
            onClick={this.handleClose}
            variant="outlined"
            color="primary"
            disabled={submitting}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapDispatchToProps = {
  fetchEnd,
  fetchStart,
  showNotification,
  refreshView
};

export default connect(
  null,
  mapDispatchToProps
)(withStyles(styles)(CategoryCreateDialog));
